var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9043 1.02549L3.67196 3.67196L1.02549 16.9043C0.983112 17.1162 0.993702 17.3353 1.05632 17.5421C1.11893 17.7489 1.23164 17.937 1.38442 18.0898L18.5212 35.2266C18.6431 35.3485 18.7878 35.4452 18.947 35.5111C19.1063 35.5771 19.2769 35.611 19.4493 35.611C19.6216 35.611 19.7923 35.5771 19.9516 35.5111C20.1108 35.4452 20.2555 35.3485 20.3774 35.2266L35.2266 20.3774C35.3485 20.2555 35.4452 20.1108 35.5111 19.9516C35.5771 19.7923 35.611 19.6216 35.611 19.4493C35.611 19.2769 35.5771 19.1063 35.5111 18.947C35.4452 18.7878 35.3485 18.6431 35.2266 18.5212L18.0898 1.38442C17.937 1.23164 17.7489 1.11893 17.5421 1.05632C17.3353 0.993702 17.1162 0.983112 16.9043 1.02549V1.02549Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5609 11.8735C11.2858 11.8735 11.8734 11.2859 11.8734 10.561C11.8734 9.83616 11.2858 9.24854 10.5609 9.24854C9.83604 9.24854 9.24841 9.83616 9.24841 10.561C9.24841 11.2859 9.83604 11.8735 10.5609 11.8735Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.87953299a9fabf0f24c6d700526e220a.svg";
export { ForwardRef as ReactComponent };